import { useMemo } from 'react';
import {
  documentScrollOver,
  exitIntent,
  onPageLoadTrigger,
  timeOnPageOver
} from '@elfsight/widget-utils';
import { useSettings } from '@wu/widget-core';
import { useStorageReward } from '../use-current-reward';

const TIME_ON_PAGE = 'timeOnPage';
const SCROLL_POSITION = 'scrollPosition';
const IMMEDIATELY = 'immediately';
const EXIT_INTENT = 'exitIntent';

export const useTriggers = () => {
  const { showPopup, popupTimeOnPage, popupScrollPosition, editMode } =
    useSettings();
  const { reward: storageReward } = useStorageReward();
  const trigger = {
    instantly: onPageLoadTrigger(IMMEDIATELY),
    afterDelay: timeOnPageOver(TIME_ON_PAGE, popupTimeOnPage),
    onScroll: documentScrollOver(SCROLL_POSITION, popupScrollPosition / 100),
    onExitIntent: exitIntent(EXIT_INTENT)
  }[showPopup];

  const memoTrigger = useMemo(() => [trigger], []);

  if (editMode || storageReward) return [];

  return memoTrigger;
};
